import classNames from 'classnames'
import React from 'react'

function Loader() {
  return (
    <div className="full-body" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', width: '100%' }}>
      <span className="spinner-border spinner-border" role="status" aria-hidden="true"></span>
    </div>
  )
}

export default Loader


export const LoadingSpinner = ({className, color}) =>{
  return (
    <>
       <div className={classNames(`spinner-grow ${!color ? 'text-primary':color}`, className)} role="status">
          <span className="sr-only">Loading...</span>
        </div>
    </>
  )
}